(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58509],{

/***/ 57982:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot_password",
      function () {
        return __webpack_require__(17671);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var uuidv4__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26281);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Shared_Alert_Alert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21550);
/* harmony import */ var _Shared_Loader_Button_loading__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86707);
/* harmony import */ var _constant_url__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99741);
/* harmony import */ var _constant_url__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_constant_url__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _constant_functions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60538);















var Forgot_password = function(param) {
    var isEmailSent = param.isEmailSent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var redirect_url = router.query.to || "/";
    // Alert
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isEmailSent), isSuccess = ref[0], setIsSuccess = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open_alert = ref1[0], setOpenAlert = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), message = ref2[0], setMessage = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("success"), alert_type = ref3[0], setAlert_type = ref3[1];
    //
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoading = ref4[0], setIsLoading = ref4[1];
    // react hook form
    var ref5 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI)(), register = ref5.register, handleSubmit = ref5.handleSubmit, setValue = ref5.setValue, errors = ref5.formState.errors;
    //
    // Submit login form
    var onSubmit = function(data) {
        setIsLoading(true);
        axios__WEBPACK_IMPORTED_MODULE_6___default().post("/api/init_reset", {
            email: data.email
        }).then(function(res) {
            setIsLoading(false);
            setIsSuccess("true");
            (0,cookies_next__WEBPACK_IMPORTED_MODULE_10__.setCookie)("forgot_pass_link_sent", true, {
                maxAge: 60 * 6 * 24,
                domain: _constant_url__WEBPACK_IMPORTED_MODULE_9__.cookies_domain_name,
                path: "/"
            });
        }).catch(function(err) {
            var ref, ref1;
            var message = err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
            setIsLoading(false);
            if (message) {
                setOpenAlert(true);
                setAlert_type("error");
                setMessage("Looks like there is no account matching the email address provided. Not to worry, you can enter valid email.");
            } else {
                if (message) {
                    setOpenAlert(true);
                    setAlert_type("error");
                    setMessage("Looks like there is no account matching the email address provided. Not to worry, you can enter valid email.");
                }
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_Alert_Alert__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: " w-full md:w-[400px] lg:w-[450px]   fixed bottom-0 md:bottom-5   right-0 z-[99999999999999999999999999999999999999999] ",
                type: alert_type,
                open: open_alert,
                setOpen: setOpenAlert,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: message
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-gradient-to-b from-gray-100 to-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-6xl mx-auto px-4 sm:px-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: " pb-12 pt-8 md:pb-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "max-w-3xl mx-auto text-center pb-10",
                                children: [
                                    isSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "1.5",
                                        stroke: "currentColor",
                                        class: "w-16 h-16 text-primary mx-auto mb-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "h1 mb-4",
                                        children: isSuccess ? "Check your email for instructions to reset your password." : "Reset your password"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xl text-gray-600",
                                        children: isSuccess ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                "If you haven't received an email in 5 minutes, check your spam or",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "text-primary underline cursor-pointer ml-1",
                                                    onClick: function() {
                                                        (0,cookies_next__WEBPACK_IMPORTED_MODULE_10__.deleteCookie)("forgot_pass_link_sent", {
                                                            domain: _constant_url__WEBPACK_IMPORTED_MODULE_9__.cookies_domain_name,
                                                            path: "/"
                                                        });
                                                        setIsSuccess(false);
                                                    },
                                                    children: "try again"
                                                }),
                                                "."
                                            ]
                                        }) : "Enter the email address associated with your account and we'll send you a link to reset your password."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "max-w-sm mx-auto",
                                children: [
                                    !isSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                        onSubmit: handleSubmit(onSubmit),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex flex-wrap -mx-3 mb-4",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "w-full px-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                            className: "block text-gray-800 text-sm font-medium mb-1",
                                                            htmlFor: "name",
                                                            children: [
                                                                "Email",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "text-red-600",
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                                            id: "name",
                                                            type: "text",
                                                            className: "form-input w-full text-gray-800",
                                                            placeholder: "Enter your email"
                                                        }, register("email")), {
                                                            required: true
                                                        }))
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex flex-wrap -mx-3 mt-6",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-full px-3",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                        type: "submit",
                                                        disabled: isLoading,
                                                        className: "btn text-white bg-blue-600 hover:bg-blue-700 w-full flex items-center justify-center gap-4 ".concat(isLoading && "cursor-not-allowed"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: "Submit"
                                                            }),
                                                            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_Loader_Button_loading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                                text_color: "text-white"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "text-sm text-gray-500 text-center mt-3",
                                                children: [
                                                    "By creating an account, you agree to the",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "underline",
                                                        href: "/terms-conditions",
                                                        target: "_blank",
                                                        children: "terms & conditions"
                                                    }),
                                                    ", and our",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "underline",
                                                        href: "/privacy-policy",
                                                        target: "_blank",
                                                        children: "privacy policy"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-gray-600 text-center mt-6",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/signin",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "text-blue-600 hover:underline transition duration-150 ease-in-out",
                                                children: "Return to sign in"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Forgot_password);


/***/ }),

/***/ 17671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Auth_Signup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38255);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_Auth_Forgot_password__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91935);








// import Header from '../partials/Header';
function Forgot_pass(param) {
    var isLoggedIn = param.isLoggedIn, isEmailSent = param.isEmailSent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var redirect_url = router.query.to || constant_url__WEBPACK_IMPORTED_MODULE_6__.default_site_url;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isLoggedIn) {
            router.push("/");
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Tradly - forgot password"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col min-h-screen overflow-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Auth_Forgot_password__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        isEmailSent: isEmailSent
                    })
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Forgot_pass);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [33714,87536,26281,88000,38255,49774,92888,40179], function() { return __webpack_exec__(57982); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);